import React, { ReactNode } from 'react';
import { Container, Box, Link } from '@mui/material';
import Header from './Header';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header onSearch={() => {}} />
      <Container maxWidth="lg" sx={{ flexGrow: 1, py: 3 }}>
        {children}
      </Container>
      <Box
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: 'auto',
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[200]
              : theme.palette.grey[800],
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ mb: 1 }}>
              Geek Bar Pulse Flavor Finder & Tracker
            </Box>
            <Box sx={{ color: 'text.secondary', fontSize: '0.875rem', mb: 2 }}>
              © {new Date().getFullYear()} - Find, track, and manage your favorite Geek Bar Pulse flavors
              <Box sx={{ mt: 1 }}>
                <Link 
                  href="https://www.vapeshopdeals.com/" 
                  target="_blank" 
                  rel="dofollow" 
                  sx={{ 
                    fontWeight: 'bold',
                    color: 'primary.main',
                    '&:hover': {
                      textDecoration: 'underline'
                    }
                  }}
                >
                  Vape Shop Deals
                </Link>
              </Box>
            </Box>
            <Box 
              sx={{ 
                color: 'text.secondary', 
                fontSize: '0.75rem', 
                backgroundColor: (theme) => theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900],
                p: 2,
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'warning.light',
              }}
            >
              <strong>WARNING:</strong> This product contains chemicals, including nicotine, which is known to the State of California to cause cancer and reproductive harm. For more information, visit <a href="https://www.p65warnings.ca.gov/" target="_blank" rel="noopener noreferrer">p65warnings.ca.gov</a>. This product is not intended for sale or use by individuals under 21 years of age. Nicotine is an addictive chemical.
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Layout;
